import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import Modal from "react-bootstrap/Modal";
import { useTranslation } from "react-i18next";
import NotificationService from "../../services/NotificationService";
import { newReminderRequestId } from "./PaymentReminderPreviewModal";

export default function PaymentReminderConsent({ clientId, onSaved, service, inline }) {
  const { t: tr } = useTranslation();
  const t = key => tr(`manage:paymentReminderV1.${key}`);
  const [open, setOpen] = useState(false);
  const [reason, setReason] = useState("");
  const [confirmed, setConfirmed] = useState(false);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);
  const command = useRef(null);
  const lock = useRef(false);
  const alive = useRef(true);
  useEffect(() => () => { alive.current = false; }, []);
  const submit = async () => {
    if (lock.current || reason.trim().length < 3 || !confirmed) return;
    lock.current = true; setBusy(true); setError("");
    if (!command.current) command.current = { requestId: newReminderRequestId(), reason: reason.trim(), confirmed: true };
    try {
      const result = await service.restorePaymentReminderConsent(clientId, command.current);
      if (alive.current) { setSaved(true); setOpen(false); onSaved(result); }
    } catch (err) {
      if (alive.current) setError(err.message || t("error"));
    } finally {
      lock.current = false;
      if (alive.current) setBusy(false);
    }
  };
  const form = (
    <>
      <Modal.Header><Modal.Title id="payment-consent-title">{t("restore")}</Modal.Title></Modal.Header>
      <Modal.Body>
        {error && <p role="alert" className="alert alert-danger">{error}</p>}
        <label htmlFor="consent-reason">{t("reason")}</label>
        <textarea className="form-control" id="consent-reason" value={reason} maxLength={1000} disabled={busy || !!command.current} onChange={e => setReason(e.target.value)} />
        <label className="mt-3" htmlFor="consent-confirm">
          <input type="checkbox" id="consent-confirm" checked={confirmed} disabled={busy || !!command.current} onChange={e => setConfirmed(e.target.checked)} /> {t("consentConfirm")}
        </label>
      </Modal.Body>
      <Modal.Footer>
        <button type="button" className="btn manage-button manage-teal-button" onClick={() => setOpen(false)}>{tr("common:back")}</button>
        <button type="button" className="btn manage-button manage-red-button" disabled={busy || !confirmed || reason.trim().length < 3} onClick={submit}>{t("restore")}</button>
      </Modal.Footer>
    </>
  );
  return (
    <>
      {saved ? <p role="status">{t("consentSaved")}</p> : <button type="button" className="btn manage-button manage-red-button mt-2" onClick={() => setOpen(true)}>{t("restore")}</button>}
      {inline ? (open && <div className="border rounded mt-3" role="group" aria-labelledby="payment-consent-title">{form}</div>) : (
        <Modal
          show={open}
          onHide={() => setOpen(false)}
          aria-labelledby="payment-consent-title"
          onEntered={node => { node.removeAttribute("aria-hidden"); node.setAttribute("aria-labelledby", "payment-consent-title"); }}
        >{form}
        </Modal>
      )}
    </>
  );
}
PaymentReminderConsent.propTypes = { clientId: PropTypes.string.isRequired, onSaved: PropTypes.func.isRequired, service: PropTypes.object, inline: PropTypes.bool };
PaymentReminderConsent.defaultProps = { service: NotificationService, inline: false };
